import { BollinoDto } from "../generated"
import DatesHelper from "../common/datesHelper"
import { orderBy } from "lodash";

export default class BolliniVerdiHelper {
    static isExpired(bollino: BollinoDto) {
        return bollino.validity.to < DatesHelper.Today();
    }

    static getLast(bolliniVerdi: BollinoDto[] | null) {
        let ultimoBollino: BollinoDto | null = null;
        if (bolliniVerdi != null) {
            const bollini = orderBy(bolliniVerdi, x => x.validity?.to);
            ultimoBollino = bollini[bollini.length - 1];
        }
        return ultimoBollino;
    }

    static getValid(bolliniVerdi: BollinoDto[] | null) {
        const today = DatesHelper.Today();
        return bolliniVerdi?.find(bollino => today >= bollino.validity.from && today <= bollino.validity.to);
    }
}